import { render, staticRenderFns } from "./WebCam.vue?vue&type=template&id=2bcf427f&scoped=true"
import script from "./WebCam.vue?vue&type=script&lang=js"
export * from "./WebCam.vue?vue&type=script&lang=js"
import style0 from "./WebCam.vue?vue&type=style&index=0&id=2bcf427f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcf427f",
  null
  
)

export default component.exports